export const isEmpty = (value: any) => {
  return value === null || (typeof value === 'string' && value.trim() === '');
};
